// @flow
import type { StoreResourceDef } from 'app/core/types'

export const groupCategoryPermissions: StoreResourceDef<> = {
  resourceType: 'groupCategoryPermissions',
}
